import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { FontFamily, TypographyV2 } from "config/font";
import { ZIndex } from "config/zIndex";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(8, 18, 30, 0.45);
  display: flex;
  justify-content: flex-end;
  z-index: ${ZIndex.sidePanel};
`;

export const Panel = styled.div`
  width: 480px;
  max-width: 90vw;
  height: 100%;
  background: ${ColorV2.White};
  padding: 48px 40px;
  box-shadow: -12px 0 32px rgba(15, 42, 64, 0.2);
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const Title = styled.h2`
  ${TypographyV2.h2};
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-family: ${FontFamily.SpaceGroteskBold}, Helvetica;
  font-size: 24px;
  font-weight: 700;
  line-height: normal;
  color: ${ColorV2.Blue1};
`;

export const SectionDescription = styled.p`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  margin: 0;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RadioOption = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`;

export const HiddenRadio = styled.input`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
`;

export const RadioControl = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 999px;
  border: 2px solid ${ColorV2.Blue1};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${ColorV2.White};

  ${RadioOption} ${HiddenRadio}:checked + &::after {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 999px;
    background: ${ColorV2.Blue1};
  }
`;

export const RadioLabel = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
`;
